import { useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select'
import { PropagateLoader } from 'react-spinners';
import { ReportSchema } from './ReportSchema.js';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { userListTodo } from '../../LMS_Redux/LMS_Slices/Masters/UserList';
import { addReportRes, addReportTodo } from '../../LMS_Redux/LMS_Slices/Report/AddReport.js';
import { reportListRes, reportListTodo } from '../../LMS_Redux/LMS_Slices/Report/ReportList.js';
import DataTables from '../LMS_DATA_TABLE/DataTable.jsx';
import { FaRedoAlt } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
import { FaLink } from 'react-icons/fa6';
import { Badge, Spinner } from 'react-bootstrap';
import { departmentListTodo } from '../../LMS_Redux/LMS_Slices/Assets/DepartmentList.js';
import { groupListTodo } from '../../LMS_Redux/LMS_Slices/Masters/GroupList.js';
import { trainingListTodo } from '../../LMS_Redux/LMS_Slices/Course/TrainingList.js';
import { courseListTodo } from '../../LMS_Redux/LMS_Slices/Course/CourseList.js';
import { learningTrackListTodo } from '../../LMS_Redux/LMS_Slices/Course/LearningTrackList.js';
import { reportViewTimeRes, reportViewTimeTodo } from '../../LMS_Redux/LMS_Slices/Report/ReportViewTime.js';
import moment from 'moment';

export default function ReportForm() {

  const [loading, setLoading] = useState(false)
  const selectInputRef = useRef();
  const dispatch = useDispatch()
  const [bool, setBool] = useState(false)
  const [spinner, setSpinner] = useState(false)

  const data = useSelector(state => state && state.reportList && state.reportList.data && state.reportList.data.data)
  const department_data = useSelector(state => state.depratmentList && state.depratmentList.data && state.depratmentList.data.data)
  const user_data = useSelector(state => state.userList && state.userList.data && state.userList.data.data)
  const group_data = useSelector(state => state.groupList && state.groupList.data && state.groupList.data.data)
  const session_data = useSelector(state => state.trainingList && state.trainingList.data && state.trainingList.data.data)
  const learning_module_data = useSelector(state => state.courseList && state.courseList.data && state.courseList.data.data)
  const learning_track_data = useSelector(state => state.learningTrackList && state.learningTrackList.data && state.learningTrackList.data.data)
  // console.log("data", learning_module_data)

  const userRole = JSON.parse(localStorage.getItem('user_data'));
  const role = userRole && userRole.vrole_name

  const initialValues = {
    type: '',
    reason: '',
    start_date: '',
    end_date: '',
    department_wise: '',
    user_wise: '',
    group_wise: '',
    session_wise: '',
    learning_module_wise: '',
    learning_track_wise: ''
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: initialValues,
    validationSchema: ReportSchema,
    enableReinitialize: true,

    onSubmit: (values, action) => {
      // console.log("new", values)
      setSpinner(true)
      dispatch(addReportTodo(values)).then(() => add_update_res(action))
    },
  })

  const type_list = [
    { value: '1', label: 'Department Wise ' },
    { value: '2', label: 'User Wise' },
    { value: '3', label: 'Group Wise' },
    { value: '4', label: 'Session Wise' },
    { value: '5', label: 'Learning Module Wise' },
    { value: '6', label: 'Learning Track Wise' },
  ]

  const dept_list = department_data && department_data.map((value) => ({
    "value": value.did,
    "label": value.vdepartment_name
  }))

  const user_list = user_data && user_data.map((value) => ({
    "value": value?.vemp_code,
    "label": value?.vemp_fname + ' - (' + value?.vemp_company_code + ')',
    "name": value?.vemp_fname,
    "code": value?.vemp_company_code,
    "department": value?.vdepartment_name,
    "designation": value?.vdesignation_name,
    "company": value?.vbusiness_area_name,
  }))

  const CustomOption = (props) => {
    const { innerRef, innerProps, isSelected, data } = props;
    return (
      <div className="ps-2 pe-2">
        <div
          ref={innerRef}
          {...innerProps}
          className="mb-1 border border-secondary border-opacity-25"
          style={{ padding: '0.5rem', borderRadius: '0.375rem', backgroundColor: isSelected ? '#cfe2ff' : '#e2e3e5' }}
        >
          <div className='d-flex justify-content-between align-items-center mb-1' style={{ fontSize: '14px' }}>
            <span className='fw-semibold text-primary'>{data.name}</span>
            <Badge pill bg="secondary">
              {data?.code}
            </Badge>
          </div>
          <hr style={{ margin: 'inherit' }} />
          <div className='d-flex justify-content-between mt-1' style={{ fontSize: '12px' }}>
            <div>
              <span>{data?.department}</span><br />
              <span className='fw-semibold'>{data?.company}</span><br />
            </div>
            <div>
              <Badge bg="warning" className='text-capitalize'>{data?.designation}</Badge>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const group_list = group_data && group_data.map((value) => ({
    "value": value.id,
    "label": value.group_name
  }))

  const session_list = session_data && session_data.map((value) => ({
    "value": value.id,
    "label": value.training_title
  }))

  const learning_module_list = learning_module_data && learning_module_data.map((value) => ({
    "value": value.id,
    "label": value.course_title
  }))

  const learning_track_list = learning_track_data && learning_track_data.map((value) => ({
    "value": value.id,
    "label": value.learning_title
  }))

  const add_update_res = (action) => {
    // console.log(addUpdateGroupRes)
    if (addReportRes && addReportRes.success) {
      action.resetForm()
      selectInputRef.current.clearValue()
      setBool(!bool)
      setSpinner(false)
      toast.success(addReportRes && addReportRes.message, { position: "bottom-right" })
    } else {
      toast.error(addReportRes && addReportRes.message, { position: "bottom-right" })
      setSpinner(false)
    }
  }

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: 'SERIAL',
      valueGetter: 'node.rowIndex + 1',
      filter: 'false',
      suppressMenu: true,
      sortable: true,
      floatingFilter: false,
      // wrapText: true,
      // autoHeight: true,
      maxWidth: 100
    },
    {
      headerName: 'FROM DATE',
      field: 'start_date',
      cellRenderer: (params) => params?.value && moment(params?.value).format('DD/MM/YYYY'),
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: true,
      // wrapText: true,
      // autoHeight: true,
    },
    {
      headerName: 'TO DATE',
      field: 'end_date',
      cellRenderer: (params) => params?.value && moment(params?.value).format('DD/MM/YYYY'),
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: true,
      // wrapText: true,
      // autoHeight: true,
    },
    {
      headerName: 'REPORT TYPE',
      field: 'report_type',
      filter: 'agTextColumnFilter',
      cellRenderer: params => params.value == '1' ? 'Department Wise' : params.value == '2' ? "User Wise" : params.value == '3' ? "Group Wise" : params.value == '4' ? "Session Wise" : params.value == '5' ? "Learning Module Wise" : params.value == '6' ? "Learning Track Wise " : '',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: true,
      // wrapText: true,
      // autoHeight: true,
    },
    {
      headerName: 'REASON',
      field: 'print_reason',
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: true,
      // wrapText: true,
      // autoHeight: true,
    },
    {
      headerName: 'STATUS',
      field: 'report_status',
      cellRenderer: params => params.value == 'success' ? <span className='badge text-bg-success text-capitalize'>{params.value}</span> : params.value == 'pending' ? <span className='badge text-bg-warning text-capitalize'>{params.value}</span> : params.value == 'failed' ? <span className='badge text-bg-danger text-capitalize'>{params.value}</span> : params.value == 'proccessing' ? <span className='badge text-bg-primary text-capitalize'>{params.value}</span> : '',
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: true,
      // wrapText: true,
      // autoHeight: true
    },
    {
      field: 'ACTIONS',
      cellRenderer: params =>
        <div>
          {params.data.report_status == 'success' ?
            // <a href={process.env.REACT_APP_IMAGE_URL + params.data.pdf_report} target='_blank'>
            <FaLink size={20} className='eye'
              data-tooltip-id='pdf'
              data-tooltip-content="PDF Report"
              data-tooltip-place="bottom"
              onClick={() => dispatch(reportViewTimeTodo(params.data.id)).then(() => report_time_res(params.data.pdf_report))}
            />
            // </a> 
            : ''}
          <Tooltip id='pdf' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
        </div>,
      // wrapText: true,
      autoHeight: true,
    }
  ])

  const report_time_res = (link) => {
    // console.log(reportViewTimeRes)
    if (reportViewTimeRes && reportViewTimeRes.success) {
      window.open(process.env.REACT_APP_IMAGE_URL + link, '_blank');
    } else {
      toast.error("Report Timed Out", { position: "bottom-right" })
      // setLoading(false)
    }
  }

  const reportList_res = () => {
    if (reportListRes && reportListRes.success) {
      setLoading(false)
    } else {
      setLoading(false)
    }
  }

  // useEffect(() => {
  //   setLoading(true)
  //   dispatch(reportListTodo()).then(() => reportList_res())
  // }, [bool])


  useEffect(() => {
    const fetchReports = () => {
      setLoading(true)
      dispatch(reportListTodo()).then(() => reportList_res())
    };

    fetchReports();
    const intervalId = setInterval(fetchReports, 30000);

    return () => {
      clearInterval(intervalId);
    };
  }, [bool]);

  useEffect(() => {
    dispatch(departmentListTodo())
    dispatch(userListTodo({ "role": "" }))
    dispatch(groupListTodo({ status: '' }))
    dispatch(trainingListTodo())
    dispatch(courseListTodo({ "temp": 'list', "course_availability": 'public', "course_type": '' }))
    dispatch(learningTrackListTodo({ "temp": "" }))
  }, [])

  return (
    <>
      <div className='container-fluid'>
        <div className='scnd-header'>
          <span className='icon1'>Reports / </span>
          <span className='icon2'>Report Management</span>
        </div>

        <div className='wrapper-admin'>

          <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
            <div className="row">

              <div className="col-12 col-md-2">
                <div className="mb-3">
                  <label htmlFor="" className="form-label form_label">From Date</label>
                  <input type="date" className="form-control form_input"
                    name='start_date' value={values.start_date} onChange={handleChange} onBlur={handleBlur}
                    max={new Date().toISOString().split('T')[0]}
                  />
                  {errors.start_date && touched.start_date ? (<span className='text-danger form_label'>{errors.start_date}</span>) : null}
                </div>
              </div>

              <div className="col-12 col-md-2">
                <div className="mb-3">
                  <label htmlFor="" className="form-label form_label">To Date</label>
                  <input type="date" className="form_input form-control"
                    name='end_date' value={values.end_date} onChange={handleChange} onBlur={handleBlur}
                    // min={values.start_date}
                    max={new Date().toISOString().split('T')[0]}
                  />
                  {errors.end_date && touched.end_date ? (<span className='text-danger form_label'>{errors.end_date}</span>) : null}
                </div>
              </div>

              <div className="col-12 col-md-3">
                <div className="mb-3">
                  <label htmlFor="" className="form-label form_label">Type</label>
                  <Select
                    ref={selectInputRef}
                    closeMenuOnSelect={true}
                    options={type_list}
                    // defaultValue={state ? data && quiz_option.find((option) => option.value == data.lms_course_quizzes.quiz_id) : ''}
                    onChange={(e) => {
                      // console.log(e)
                      setFieldValue('type', e && e.value || '');
                      if (role == "Instructor" && e?.value == '1') {
                        setFieldValue('department_wise', userRole.dept_id);
                      } else {
                        setFieldValue('department_wise', '');
                      }
                      setFieldValue('user_wise', '');
                      setFieldValue('group_wise', '');
                      setFieldValue('session_wise', '');
                      setFieldValue('learning_module_wise', '');
                      setFieldValue('learning_track_wise', '');
                    }}
                    onBlur={handleBlur}
                    name='type'
                    // isMulti
                    placeholder="Select Type"
                    classNamePrefix="select"
                  />
                  {errors.type && touched.type ? (<span className='text-danger form_label'>{errors.type}</span>) : null}
                </div>
              </div>

              {values.type == '1' ?
                <div className="col-12 col-md-5">
                  <div className="mb-3">
                    <label htmlFor="" className="form-label form_label">Department Wise</label>
                    <Select
                      closeMenuOnSelect={true}
                      options={dept_list && dept_list || []}
                      defaultValue={dept_list && dept_list.find((option) => option.value == values.department_wise)}
                      onChange={(e) =>
                        // console.log(e)
                        setFieldValue('department_wise', e && e.value || '')
                      }
                      onBlur={handleBlur}
                      name='department_wise'
                      // isMulti
                      placeholder="Select Department"
                      classNamePrefix="select"
                      isDisabled={role == "Instructor" ? true : false}
                    />
                    {errors.department_wise && touched.department_wise ? (<span className='text-danger form_label'>{errors.department_wise}</span>) : null}
                  </div>
                </div>
                : ''
              }

              {values.type == '2' ?
                <div className="col-12 col-md-5">
                  <div className="mb-3">
                    <label htmlFor="" className="form-label form_label">User Wise</label>
                    <Select
                      closeMenuOnSelect={true}
                      options={user_list && user_list || []}
                      components={{ Option: CustomOption }}
                      // defaultValue={state ? data && quiz_option.find((option) => option.value == data.lms_course_quizzes.quiz_id) : ''}
                      onChange={(e) =>
                        // console.log(e)
                        setFieldValue('user_wise', e && e.value || '')
                      }
                      onBlur={handleBlur}
                      name='user_wise'
                      // isMulti
                      placeholder="Select User"
                      classNamePrefix="select"
                    />
                    {errors.user_wise && touched.user_wise ? (<span className='text-danger form_label'>{errors.user_wise}</span>) : null}
                  </div>
                </div>
                : ''
              }

              {values.type == '3' ?
                <div className="col-12 col-md-5">
                  <div className="mb-3">
                    <label htmlFor="" className="form-label form_label">Group Wise</label>
                    <Select
                      closeMenuOnSelect={true}
                      options={group_list && group_list || []}
                      // defaultValue={state ? data && quiz_option.find((option) => option.value == data.lms_course_quizzes.quiz_id) : ''}
                      onChange={(e) =>
                        // console.log(e)
                        setFieldValue('group_wise', e && e.value || '')
                      }
                      onBlur={handleBlur}
                      name='group_wise'
                      // isMulti
                      placeholder="Select Group"
                      classNamePrefix="select"
                    />
                    {errors.group_wise && touched.group_wise ? (<span className='text-danger form_label'>{errors.group_wise}</span>) : null}
                  </div>
                </div>
                : ''
              }

              {values.type == '4' ?
                <div className="col-12 col-md-5">
                  <div className="mb-3">
                    <label htmlFor="" className="form-label form_label">Session Wise</label>
                    <Select
                      closeMenuOnSelect={true}
                      options={session_list && session_list || []}
                      // defaultValue={state ? data && quiz_option.find((option) => option.value == data.lms_course_quizzes.quiz_id) : ''}
                      onChange={(e) =>
                        // console.log(e)
                        setFieldValue('session_wise', e && e.value || '')
                      }
                      onBlur={handleBlur}
                      name='session_wise'
                      // isMulti
                      placeholder="Select Session"
                      classNamePrefix="select"
                    />
                    {errors.session_wise && touched.session_wise ? (<span className='text-danger form_label'>{errors.session_wise}</span>) : null}
                  </div>
                </div>
                : ''
              }

              {values.type == '5' ?
                <div className="col-12 col-md-5">
                  <div className="mb-3">
                    <label htmlFor="" className="form-label form_label">Learning Module Wise</label>
                    <Select
                      closeMenuOnSelect={true}
                      options={learning_module_list && learning_module_list || []}
                      // defaultValue={state ? data && quiz_option.find((option) => option.value == data.lms_course_quizzes.quiz_id) : ''}
                      onChange={(e) =>
                        // console.log(e)
                        setFieldValue('learning_module_wise', e && e.value || '')
                      }
                      onBlur={handleBlur}
                      name='learning_module_wise'
                      // isMulti
                      placeholder="Select Learning Module"
                      classNamePrefix="select"
                    />
                    {errors.learning_module_wise && touched.learning_module_wise ? (<span className='text-danger form_label'>{errors.learning_module_wise}</span>) : null}
                  </div>
                </div>
                : ''
              }

              {values.type == '6' ?
                <div className="col-12 col-md-5">
                  <div className="mb-3">
                    <label htmlFor="" className="form-label form_label">Learning Track Wise</label>
                    <Select
                      closeMenuOnSelect={true}
                      options={learning_track_list && learning_track_list || []}
                      // defaultValue={state ? data && quiz_option.find((option) => option.value == data.lms_course_quizzes.quiz_id) : ''}
                      onChange={(e) =>
                        // console.log(e)
                        setFieldValue('learning_track_wise', e && e.value || '')
                      }
                      onBlur={handleBlur}
                      name='learning_track_wise'
                      // isMulti
                      placeholder="Select Learning Track"
                      classNamePrefix="select"
                    />
                    {errors.learning_track_wise && touched.learning_track_wise ? (<span className='text-danger form_label'>{errors.learning_track_wise}</span>) : null}
                  </div>
                </div>
                : ''
              }


              <div className="col-12 col-md-5">
                <div className="mb-3">
                  <label htmlFor="" className="form-label form_label">Reason</label>
                  <textarea className="form-control form_input" rows="1"
                    name='reason' value={values.reason || ''} onChange={handleChange} onBlur={handleBlur}
                  />
                  {errors.reason && touched.reason ? (<span className='text-danger form_label'>{errors.reason}</span>) : null}
                </div>
              </div>
            </div>

            <div className='text-end mt-4'>
              <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Print  {spinner ?
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className='ms-2'
                />
                : ''
              }</button>
            </div>
          </form>

        </div>
        <div className='mt-3'>
          {/* <div className='d-flex justify-content-end'>
            <button type='button' className='btn btn-primary btn-sm' onClick={() => setBool(!bool)}>
              <FaRedoAlt style={{ color: 'white' }} />
            </button>
          </div> */}
          {loading ?
            <div className='wrapper-admin mt-2'>
              <div className='text-center mb-3'>
                <PropagateLoader
                  color="#2262C6"
                  size={20}
                />
              </div>
            </div>
            :
            <>
              {data && data.length ?
                <DataTables
                  rowData={data}
                  columnDefs={columnDefs}
                // columnDefs={columnDefs.filter((colDef) => colDef !== null)}
                />
                :
                <div className='wrapper-admin'>
                  <div className='text-center'>
                    <h5>Report List Not Found</h5>
                  </div>
                </div>}
            </>}
        </div>
      </div>

      <ToastContainer />
    </>
  )
}
